import React from 'react';
import logo from '../../images/logo.svg';

const IconLoader = () => <img src={logo} alt="Logo" style={{ width: '100px', height: '100px' }} />;

export default IconLoader;
